import React from 'react';
import { Shield, Clock, ThumbsUp, Users } from 'lucide-react';

const AboutSection = () => {
  const features = [
    {
      icon: Shield,
      title: "Safe & Secure",
      description: "All vehicles are sanitized and drivers are verified for your safety"
    },
    {
      icon: Clock,
      title: "24/7 Availability",
      description: "Round the clock service available for all your travel needs"
    },
    {
      icon: ThumbsUp,
      title: "Affordable Rates",
      description: "Competitive pricing with no hidden charges or surprises"
    },
    {
      icon: Users,
      title: "Professional Drivers",
      description: "Experienced, courteous drivers who know the routes well"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Choose <span className="text-orange-600">Us?</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Gulmohar Global Travels is your trusted partner for safe, comfortable, and affordable travel in Varanasi and across Uttar Pradesh.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="text-center p-6 rounded-2xl bg-gradient-to-b from-orange-50 to-white border border-orange-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="bg-orange-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </div>
              );
            })}
          </div>

          <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-8 md:p-12 border border-orange-200">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Best Taxi & Cab Service in Varanasi
              </h3>
              <p className="text-gray-700 leading-relaxed">
                With years of experience in the travel industry, Gulmohar Global Travels has become Varanasi's most trusted taxi service provider. We offer local taxi services, outstation cab bookings, airport transfers, tempo traveller rentals, and bus bookings for events. Whether you're visiting the sacred ghats of Varanasi, planning a pilgrimage to Ayodhya, or exploring the Taj Mahal in Agra, we ensure a comfortable and memorable journey. Our fleet includes well-maintained vehicles from economical Maruti Dzire to spacious 45-seater buses, catering to all your travel needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
